@if (categoryMetadata; as metadata) {
    <div #category
         class="category-container">
        <div class="category"
             [style.--category-colour]="metadata.colour">
            @if (metadata.icon) {
                <i [ngClass]="metadata.icon"></i>
            }
        </div>
        <!-- container set to this div so that it stays open while hovering the tooltip itself -->
        <dx-tooltip [target]="category"
                    [container]="category"
                    [hideOnParentScroll]="true"
                    class="dx-tooltip-element"
                    showEvent="dxhoverstart"
                    hideEvent="dxhoverend"
                    [position]="{
                my: showPlainTooltip ? 'bottom' : 'right',
                at: showPlainTooltip ? 'top' : 'left',
                collision: 'flip none',
            }"
                    [maxWidth]="600">
            <div *dxTemplate="let data of 'content'">
                <div class="adapt-tooltip-content text-start">
                    {{ showPlainTooltip ? metadata.name : metadata.description }}
                </div>
                @if (latestOdScoreString && !showPlainTooltip) {
                    <div class="category-score">
                        Health Check Score: {{ latestOdScoreString }}%
                        @if (odSurveySummaryPageRoute; as summaryPageRoute) {
                            <a class="btn btn-primary"
                               [routerLink]="summaryPageRoute.path"
                               [queryParams]="summaryPageRoute.queryParams">See Health Check Details</a>
                        }
                    </div>
                }
            </div>
        </dx-tooltip>
    </div>
}
